import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';;


@Component({
  selector: 'iho-login-register-wrapper',
  templateUrl: './login-register-wrapper.component.html',
  styleUrls: ['./login-register-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MatDialogModule]


})
export class LoginRegisterWrapperComponent implements OnInit, AfterViewInit {
  phoneNumber: string = '';
  itemStep: string = '';
  typeSection: string = '';
  EmailMobile: string = '';
  isForgetPass: boolean = false;
  responseActivationCode:any;
  ModelVerify: any = {};
  cdnUrl = cdnUrl
  constructor(public dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<LoginRegisterWrapperComponent>,
    @Inject(PLATFORM_ID) private platformId: Object

  ) {

  }
  ngOnInit(): void {
    this.cdr.markForCheck();

  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) setTimeout(() => {
      this.itemStep = 'step-register';
      this.cdr.markForCheck();
    }, 100);
  }
  closeModal() {
    this.dialogRef.close()
    // this.router.navigate([], { relativeTo: this.route, queryParams: {} });
  }

  phoneNumberChange(ev: string) {
    this.phoneNumber = ev;
    this.itemStep = 'step-otp';
    this.isForgetPass = false;


  }
  status(step: string) {
    this.itemStep = step;
  }

  emitActivationCode(ev: any) {
    this.responseActivationCode = ev;
  }

  emitModelVerify(ev: any) {
    this.ModelVerify = ev;
  }

  emitEmailMobile(ev: any) {
    this.EmailMobile = ev;
    this.isForgetPass = true;
  }
}
